import {Injectable} from "@angular/core";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

export interface SanitizedUrl {
  readonly sanitizedUrl: SafeResourceUrl;
  readonly url: string;
}

@Injectable()
export class ConvertPdfBase64ToResourceUrlService {

  constructor(
    protected readonly sanitizer: DomSanitizer
  ) {
  }

  convert(base64: string): SanitizedUrl {
    const byteCharacters = atob(base64!);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) =>
      byteCharacters.charCodeAt(i)
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: "application/pdf"});

    const url = URL.createObjectURL(blob);
    const viewerUrl = `${url}#navpanes=0&zoom=page-width`; // hide sidebar + toolbar, fit to page

    return {
      sanitizedUrl: this.sanitizer.bypassSecurityTrustResourceUrl(viewerUrl),
      url: url
    };
  }
}
